



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { IFacetValue, IFilter } from '../Scripts/ISearchService';
import { FilterHelper } from '../Scripts/FilterHelper';
import { IFacet } from '../Scripts/FacetDefinition';

import ActionTracker, { FacetSelectedEvent } from '../Scripts/AnalyticsEvents';

import RemoteHelp from './RemoteHelp.vue';

@Component({
	components: {
		RemoteHelp
	}
})
export default class FacetCard extends Vue {
	@Prop() public metadata!: IFacet;
	@Prop() public values!: IFacetValue[];

	private initialFacetsToShow = 3;

	get show (): boolean {
		return this.values && this.values.length > 0;
	}

	get helpTarget (): string {
		return `button-${this.metadata.column}`;
	}

	get helpTitle (): string {
		return `${this.metadata.label}`;
	}

	get helpModalId (): string {
		return `${this.metadata.helpName}-modal`;
	}

	get topValues (): IFacetValue[] {
		const filter = this.relevantFilter;

		const top = filter
			? this.values.filter((v: IFacetValue) => v.value === filter.value)
			: this.values.slice(0, this.initialFacetsToShow);

		return top.map((f) => {
			return { count: f.count, value: f.value, display: this.metadata.getTitle(f.value) } as IFacetValue;
		});
	}

	get more (): boolean {
		return this.values.length > this.initialFacetsToShow;
	}

	get relevantFilter (): IFilter | undefined {
		return this.$store.state.filters.find((f: IFilter) => f.key === this.metadata.column);
	}

	public isSelected (item: IFacetValue): boolean {
		return this.relevantFilter !== undefined && this.relevantFilter.value === item.value;
	}

	public explore (): void {
		this.$emit('explore', this.metadata.column, this.metadata.label);
	}

	public toogleSelected (item: IFacetValue): void {
		const helper = new FilterHelper(this.$router);

		if (this.isSelected(item)) {
			helper.clearFilter(this.metadata.query);
		} else {
			ActionTracker.track(new FacetSelectedEvent(this.metadata.query, item.value));
			helper.setFilter(this.metadata.query, item.value);
		}
	}
}
